export const ClassNames = Object.freeze({
	Block: 'block',
	Error: 'has-error',
	Focused: 'is-focused',
	HasIcon: 'has-icon',
	FlexClass: 'u-flex',
	Hidden: 'u-hidden',
	Invalid: 'is-invalid',
	InvalidWrapper: 'is-invalid-wrapper',
	None: 'none',
	SearchInputField: '.lta-search-input-field',
	Show: 'show',
	TextInputError: '.lta-text-input--error'
});
